import ThreeCVoipService from '@/shared/services/voip/ThreeCVoipService'

class Voip3CPlusRepository {
  constructor () {
    this.voipService = ThreeCVoipService
  }

  async initialize () {
    return this.voipService.initialize()
  }

  async getCampaigns () {
    return this.voipService.getCampaigns()
  }

  async connectVoip (connectionData) {
    const { campaignId } = connectionData
    if (!campaignId) {
      throw new Error('ID da campanha é obrigatório')
    }
    return this.voipService.loginAgent(campaignId)
  }

  async disconnectVoip () {
    return this.voipService.logoutAgent()
  }

  async makeCall (callData) {
    const { phoneNumber } = callData
    if (!phoneNumber) {
      throw new Error('Número de telefone é obrigatório')
    }
    return this.voipService.dialNumber(phoneNumber)
  }

  async endCall (callId) {
    if (!callId) {
      throw new Error('ID da chamada é obrigatório')
    }
    return this.voipService.hangupCall()
  }

  async enterManualMode () {
    return this.voipService.enterManualMode()
  }

  getConnectionStatus () {
    return {
      initialized: this.voipService.initialized,
      agentLoggedIn: this.voipService.agentLoggedIn,
      inManualMode: this.voipService.inManualMode,
      callId: this.voipService.callId,
      campaignId: this.voipService.campaignId
    }
  }

  on (event, callback) {
    this.voipService.on(event, callback)
  }

  off (event, callback) {
    this.voipService.off(event, callback)
  }

  disconnect () {
    this.voipService.disconnect()
  }
}

export default new Voip3CPlusRepository()



// WEBPACK FOOTER //
// ./src/shared/http/repositories/voip/voip3cplus.js